import React, { useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Export,
    ColumnChooser,
    ColumnChooserSearch,
    FilterRow,
    Sorting,
    Paging,
    Pager,
    Selection,
} from "devextreme-react/data-grid";
import { loadDatasource } from "../../../common/Utils";
import apiRoutes from "../../../assets/apiRoutes.json";
import { OpenFollowUpColumns, highlightOverdueFollowUpRow } from './Layout';
import { GRID_PAGE_SIZES } from './constants';

// Reuses the same GetCollectionCreditHeaders query and the shared OpenFollowUpColumns /
// highlightOverdueFollowUpRow definitions as List.js's own "Open Follow-up" tab, mirroring
// ARD0009's grdOpenFollowUpTop - selecting a row here drives the Followup/Details panel
// below it, same as legacy's qryARCOLLECTIONCREDITHEADERRead selection.
const OpenFollowUpGrid = (props) => {
    const accessToken = props.oidc?.user?.access_token;

    const dataSource = useMemo(
        () => loadDatasource(accessToken, `${window._env_.REACT_APP_APIS}/${apiRoutes.CollectionCreditHeader.GetCollectionCreditHeaders}`, 'RowId'),
        [accessToken]
    );

    const onSelectionChanged = ({ selectedRowsData }) => {
        const header = selectedRowsData && selectedRowsData.length === 1 ? selectedRowsData[0] : null;
        props.onFollowUpChanged(header);
    };

    return (
        <DataGrid
            dataSource={dataSource}
            // Fills whatever definite-height box the caller wraps this in - see
            // CustomerBrowseGrid's own height comment for why this can't rely on the
            // app's "search-page-grid" (height:100%) convention here.
            height="100%"
            allowColumnReordering={true}
            allowColumnResizing={true}
            showBorders={true}
            hoverStateEnabled={true}
            onSelectionChanged={onSelectionChanged}
            onRowPrepared={highlightOverdueFollowUpRow}
            remoteOperations={true}
            searchEnabled={true}
            columnAutoWidth={true}
        >
            <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <Export enabled={true} />
            <Selection mode="single" />
            <Sorting visible={true} mode="multiple" />
            <Paging defaultPageSize={10} />
            <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={GRID_PAGE_SIZES} showNavigationButtons={true} />
            <FilterRow visible={true} />
            {OpenFollowUpColumns.map((column) => (
                <Column key={column.dataField} {...column} />
            ))}
        </DataGrid>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(OpenFollowUpGrid);
